import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import {
  Carousel,
  CarouselControl,
  CarouselIndicators,
  Table,
  Modal,
} from 'reactstrap';

export const Container = styled.div`
  width: 100%;
  height: calc(100vh - 48px);
  overflow-y: auto;
  padding: 20px;
`;

export const Header = styled.header`
  width: 100%;
  gap: 16px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding-bottom: 16px;

  h2 {
    font-weight: bold;
  }
`;

export const MessageContainer = styled.div`
  background-color: #e8f8ff;
  border: 1px solid #85d0f2;
  margin-left: 10px;
  padding: 20px;
  border-radius: 5px;
  margin-top: 20px;
`;
export const SearchBar = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 40px;
  margin-right: 10px;
  position: relative;

  input {
    width: 300px;
    font-size: 12px;
    background: #fff;
    color: #333;
    border: 1px solid #33333370;
    border-radius: 4px;
    padding: 17px;
    padding-left: 28px;
    ::placeholder {
      color: #333;
    }
  }
`;
export const ButtonDeleteInput = styled.button`
  background: transparent;
  border: none;

  border-radius: 8px;
  position: absolute;
  left: 280px;
  bottom: 11px;

  svg {
    color: #33333340;
  }
`;

export const ButtonSearchInput = styled.button`
  background: transparent;
  border: none;

  border-radius: 8px;
  position: absolute;
  left: 10px;
  bottom: 11px;
  svg {
    color: #333;
  }
`;

export const CardMain = styled.main`
  width: 97%;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  margin-left: 30px;
  background: #fff;

  span {
    font-size: 22px;
    font-weight: bold;
  }
`;

export const Card = styled(Table)`
  width: 100%;
  min-width: 400px;
  align-items: center;
  border-radius: 7px;
  border-collapse: separate;
  border-spacing: 0 20px;
  background: #fff;

  padding: 0 30px;
  margin: 20px auto;

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    border-top: none;
    tr {
      th {
        button {
          border: none;
          background-color: transparent;
          font-weight: bold;
          color: #333;
        }
      }
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    tr {
      td {
        border-bottom: 1px solid #33333310;
      }
    }
    td:last-child {
      text-align: right;
    }
  }
`;

export const DatePickerStyledUnify = styled(DatePicker)`
  height: 40px;
  margin-top: 4px !important;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #545454;
  width: 100% !important;
  margin-top: 8px;
  &:focus {
    border: 1px solid #c8131b;
    border-radius: 8px;
  }
`;

export const DatePickerWrapper = styled.div`
  width: 100%;
  margin-bottom: 6px;
  position: relative;

  .react-datepicker-wrapper {
    width: 100%;
    height: 40px;
  }

  .react-datepicker__input-container input {
    width: 100%;
    height: 40px;
    padding: 10px;
    border-radius: 8px;
    margin-top: 8px;
  }
`;

export const CarouselStyled = styled(Carousel)`
  width: 100%;

  img {
    width: 500px;
  }
`;

export const CarouselIndicatorsStyled = styled(CarouselIndicators)`
  margin-bottom: 80px;
  button {
    background-color: #33333370 !important;
  }
`;

export const CarouselControlStyled = styled(CarouselControl)`
  button {
    fill: #2ec9b7 !important;
    color: #2ec9b7 !important;
  }
`;

export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 8px;
`;

export const TitleHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10;
  margin-bottom: 20;
`;

export const TitleTerm = styled.p`
  font-family: Poppins;
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  color: var(--Takeat-Colors-Neutrals-Black-01, #222) !important;
`;

export const PrazoHeaderSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const CrdWhite = styled.div`
  display: flex;
  width: 100%;
  align-self: stretch;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  justify-content: center;

  flex-direction: ${({ $checkbox }) => ($checkbox ? 'column' : 'row')};
  max-width: ${({ $checkbox }) => ($checkbox ? '' : '288px')};
  gap: ${({ $checkbox }) => ($checkbox ? '8px' : '16px')};
`;

export const CardItems = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 16px;
`;

export const ItemIcon = styled.figure`
  display: flex;
  width: 56px;
  height: 56px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 2px 0;
  margin: 0;
`;

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  width: max-content;
`;

export const NumberPrice = styled.span`
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 127.273% */
  letter-spacing: var(--Headline-Small-Tracking, 0px);
  color: var(--Takeat-Colors-Neutrals-Grey-01, #545454) !important;
  /* Title/Title Large/Medium | 500 */
`;

export const TitleSale = styled.span`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;

  font-size: ${({ $titleModal }) => ($titleModal ? '18px' : '16px')};
  letter-spacing: ${({ $titleModal }) =>
    $titleModal
      ? 'letter-spacing: var(--Headline-Small-Tracking, 0px)'
      : '0.15px'};
  color: ${({ $titleModal }) =>
    $titleModal
      ? 'var(--Takeat-Colors-Neutrals-Black-01, #222)'
      : 'var(--Takeat-Colors-Neutrals-Grey-01, #545454)'} !important;
`;
export const CardCheckbox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

export const ItemCheckbox = styled.div`
  display: flex;
  padding: 4px;
  align-items: center;
  gap: 8px;
  position: relative;
`;
export const TitleCheckbox = styled.span`
  font-family: Poppins;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  vertical-align: middle;
  color: var(--Takeat-Colors-Neutrals-Grey-01, #545454) !important;
`;

export const CardItemsCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
`;

export const HeaderAccount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: ${({ $noAccount }) => ($noAccount ? 'center' : 'stretch')};
  gap: 16px;
`;

export const ButtonsInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const InputInfo = styled.div`
  display: flex;
  width: 210px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const ButtonAtt = styled.div``;

export const ListWhite = styled.div`
  height: ${({ $noAccount }) => ($noAccount ? '80%' : 'auto')};
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  justify-content: ${({ $noAccount }) => ($noAccount ? 'center' : 'flex-end')};
  align-items: ${({ $noAccount }) => ($noAccount ? 'center' : 'flex-end')};
  gap: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);
`;

export const TheadTitle = styled.thead`
  display: flex;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--Takeat-Colors-Neutrals-White-02, #f6f6f6);
  background: var(--Takeat-Colors-Neutrals-White, #fff);
`;
export const TrTitle = styled.tr`
  display: flex;
  padding: 16px;
  width: 100%;
  align-items: center;

  justify-content: ${({ $trNameAccount, $trNameAction }) => {
    if ($trNameAccount) return 'flex-start';
    if ($trNameAction) return 'flex-end';
    return 'center';
  }};
`;

export const ThTitle = styled.th`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  text-align: center;

  /* Title/Title Small/Semibold | 600 */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
`;

export const TBodyInfo = styled.thead`
  border-bottom: 1px solid #33333310;
  display: flex;
  gap: 12px;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

export const Td = styled.td`
  border-bottom: 1px solid #33333310;
`;

export const HeaderData = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Takeat-Colors-Primary-Red, #c8131b);
  background: var(--Takeat-Colors-Neutrals-White, #fff) !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);
`;

export const HeaderForm = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 16px 16px 8px 16px;
  gap: 10px;
`;

export const ModalBodyy = styled.div`
  display: flex;
  padding: 0px 8px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  background: #fff;
`;

export const FormFields = styled.div`
  display: flex;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
`;

export const FieldInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  gap: 5px;
`;

export const StyledModal = styled(Modal)`
  .modal-content {
    display: flex;
    padding: 16px 16px 8px 16px;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    align-self: stretch;
    border-radius: 12px;
    background: #fff;
  }
`;
export const TextTooltip = styled.span`
  color: var(--Takeat-Colors-Neutrals-Grey-02, #7a7a7a);

  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.4px;
`;

export const ToolTipModal = styled.div``;

export const FooterModal = styled.div`
  display: flex;
  padding: 12px 8px 12px 16px;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

export const CalendarInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const NoAccount = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
`;

export const Therm = styled.div `
  position: relative;
  display: flex;
    align-items: center;
    gap: 4px;

`